import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

// Full Sign Up API
export const signup = (data) => {
  let payload = JSON.stringify(data);

  let config = {
    method: "post",
    url: `${baseUrl}/api/user/createuser`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("yacht signup error: ", error.response);
      return error?.response?.data;
    });

  return res;
};

// Light Sign Up API
export const lightSignup = (data) => {
  let payload = JSON.stringify(data);
  let config = {
    method: "POST",
    url: `${baseUrl}/api/user/signup`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload
  };

  const res = axios.request(config).then(response => {
    return response?.data;
  }).catch(err => {
    console.log("Signup error: ", err);
    return err?.response?.data;
  });

  return res;
}

export const login = (data) => {
  let payload = JSON.stringify(data);

  let config = {
    method: "post",
    url: `${baseUrl}/api/user/login`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      console.log("login error: ", error);
      return error?.response?.data;
    });

  return res;
};

export const logout = (token) => {
  let config = {
    method: "post",
    url: `${baseUrl}/api/user/logout`,
    headers: {
      token: token
    }
  }

  const res = axios(config).then(response => {
    return response?.data;
  }).catch((err) => {
    console.error("logout error: ", err);
    return err?.response?.data ?? null;
  })

  return res;
}

export const forgotPassword = (data) => {
  let payload = JSON.stringify({
    userName: data,
    subject: "Reset your password",
    mailBodyType: "HTML",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/forgotpassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  };

  const res = axios
    .request(config)
    .then((response) => {
      console.log("forgot password: ", response?.data);
      return response?.data;
    })
    .catch((error) => {
      console.log("forgot password error: ", error?.response);
      return error?.response?.data;
    });

  return res;
};

export const resetPassword = (data, token) => {
  let payload = JSON.stringify(data);

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/resetPassword`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  const res = axios
    .request(config)
    .then((response) => {
      console.log("supplier signup: ", response.data);
      return response.data;
    })
    .catch((error) => {
      console.log("supplier signup error: ", error.response);
      return error.response.data;
    });

  return res;
};

export const uploadInsurance = (file, id) => {
  let data = new FormData();
  data.append("file", file);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/uploadinsurance?id=${id}`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      console.log("error in upload insurance", error);
      return error.response;
    });
  return res;
};

export const uploadRegistration = (file, id) => {
  let data = new FormData();
  data.append("file", file);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/uploadregistration?id=${id}`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      console.log("error in upload registration", error);
      return error?.response;
    });
  return res;
};

export const getUserByUsername = (username, token) => {
  let config = {
    method: "get",
    url: `${baseUrl}/api/user/getuserbyusername/${username}`,
    headers: {
      token: token,
    },
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in getUserByUsername: ", error);
      return error.response.data;
    });
  return res;
};

export const updateUserByUsername = (data, token) => {
  let payload = JSON.stringify(data);

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/updateuserbyusername`,
    headers: {
      token: token,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in updateUserByUsername: ", error);
      return error.response.data;
    });
  return res;
};

export const updateProfileImage = (file, token) => {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("file_upload", file);
  data.append("folder", "profile");

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/user/uploadprofileimage?folder=profile`,
    headers: {
      token: token,
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  const res = axios
    .request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error in upload profile image", error);
      return error.response.data;
    });

  return res;
};

export const completeProfile = (data, token) => {
  let config = {
    method: "PUT",
    url: `${baseUrl}/api/user/completeprofile`,
    headers: {
      token: token,
      // "Content-Type": "multipart/form-data",
    },
    data: data
  }

  const res = axios.request(config).then(response => {
    return response.data
  }).catch(err => {
    console.log("complete profile error: ", err);
    return err.response.data
  })

  return res;
}